import React, { useState } from 'react';
import { useRates } from '../../contexts/RatesContext';
import { settingsAPI } from '../../services/api';

const MetalRates = () => {
  const { rates, updateRate, canEdit, replaceRates } = useRates();
  const [syncing, setSyncing] = useState(false);

  const handleChange = (metal, purity) => (e) => {
    updateRate(metal, purity, e.target.value);
  };

  const syncFromGoldAPI = async () => {
    if (!canEdit || syncing) return;
    setSyncing(true);
    try {
      const res = await settingsAPI.syncMetalRates();
      const newRates = res?.data?.data;
      if (newRates) {
        replaceRates(newRates, false);
      }
    } catch (e) {
      // Optionally handle error via toast
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Metal Rates</h1>
      <div className="bg-white shadow rounded-lg p-6 space-y-6">
        <div className="flex items-center justify-between">
          <p className="text-sm text-gray-500">Sync market rates from GoldAPI (INR per gram).</p>
          <button
            onClick={syncFromGoldAPI}
            disabled={!canEdit || syncing}
            className={`btn btn-primary ${(!canEdit || syncing) ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            {syncing ? 'Syncing…' : 'Sync from GoldAPI'}
          </button>
        </div>
        <section>
          <h2 className="text-lg font-semibold mb-3">Gold (per gram)</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {Object.keys(rates.gold).map((purity) => (
              <div key={purity}>
                <label className="block text-sm font-medium text-gray-700">{purity}</label>
                <input
                  type="number"
                  className="input mt-1"
                  step="0.01"
                  value={rates.gold[purity] || 0}
                  onChange={handleChange('gold', purity)}
                  disabled={!canEdit}
                />
              </div>
            ))}
            {/* Add manual standard option if missing */}
            {!('Standard' in rates.gold) && (
              <div>
                <label className="block text-sm font-medium text-gray-700">Standard</label>
                <input
                  type="number"
                  className="input mt-1"
                  step="0.01"
                  value={0}
                  onChange={handleChange('gold', 'Standard')}
                  disabled={!canEdit}
                />
              </div>
            )}
          </div>
        </section>

        <section>
          <h2 className="text-lg font-semibold mb-3">Silver (per gram)</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {Object.keys(rates.silver).map((purity) => (
              <div key={purity}>
                <label className="block text-sm font-medium text-gray-700">{purity}</label>
                <input
                  type="number"
                  className="input mt-1"
                  step="0.01"
                  value={rates.silver[purity] || 0}
                  onChange={handleChange('silver', purity)}
                  disabled={!canEdit}
                />
              </div>
            ))}
            {/* Add manual standard option if missing */}
            {!('Standard' in rates.silver) && (
              <div>
                <label className="block text-sm font-medium text-gray-700">Standard</label>
                <input
                  type="number"
                  className="input mt-1"
                  step="0.01"
                  value={0}
                  onChange={handleChange('silver', 'Standard')}
                  disabled={!canEdit}
                />
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default MetalRates;


